import script from "./ChooseCoverImageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChooseCoverImageModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChooseCoverImageModal.vue?vue&type=style&index=0&id=02f68642&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f68642"]])

export default __exports__